var _rect, _g, _rect2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderBannerBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 246,
    viewBox: "0 0 360 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10703_192421)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 347,
    fill: "url(#paint0_linear_10703_192421)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.543 120.457C304.846 120.444 302.214 121.287 300.026 122.865C300.115 120.789 299.777 118.717 299.034 116.776C298.291 114.835 297.158 113.068 295.705 111.582C294.252 110.096 292.51 108.923 290.587 108.137C288.663 107.35 286.599 106.966 284.521 107.008C281.667 106.915 278.846 107.639 276.391 109.096C273.935 110.553 271.947 112.681 270.661 115.23C269.021 113.191 266.947 111.542 264.59 110.404C262.233 109.267 259.652 108.668 257.035 108.652C253.053 108.674 249.195 110.045 246.091 112.541C242.987 115.037 240.821 118.51 239.945 122.395C238.195 120.728 236.053 119.531 233.717 118.913C231.381 118.296 228.926 118.28 226.582 118.866C224.238 119.452 222.08 120.622 220.309 122.265C218.538 123.909 217.211 125.974 216.452 128.268C215.364 127.773 214.183 127.513 212.987 127.505C211.076 127.518 209.229 128.2 207.77 129.435C206.31 130.669 205.33 132.376 205 134.259H320.405C320.517 130.727 319.227 127.294 316.818 124.708C314.408 122.123 311.075 120.595 307.543 120.457Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0381 159.846C27.1475 159.853 29.2018 160.545 30.9131 161.823C30.8451 160.145 31.1093 158.47 31.6895 156.901C32.2697 155.333 33.1536 153.904 34.2866 152.704C35.4197 151.503 36.778 150.555 38.2777 149.92C39.7774 149.284 41.3868 148.974 43.0066 149.008C45.2362 148.926 47.4417 149.509 49.3618 150.686C51.282 151.864 52.8364 153.587 53.8412 155.653C55.1064 153.994 56.7185 152.655 58.5557 151.737C60.393 150.819 62.4073 150.346 64.4468 150.352C67.5711 150.349 70.6026 151.454 73.0383 153.483C75.4739 155.511 77.1672 158.343 77.8374 161.507C79.8847 159.45 82.6167 158.289 85.4673 158.263C87.8106 158.268 90.0936 159.034 91.9958 160.452C93.8979 161.871 95.3237 163.872 96.0729 166.174C96.954 165.737 97.921 165.519 98.8975 165.536C99.874 165.554 100.833 165.807 101.699 166.275C102.565 166.743 103.314 167.414 103.887 168.234C104.46 169.054 104.841 170.001 105 171H15.0047C14.9221 168.145 15.9298 165.372 17.8086 163.283C19.6874 161.194 22.2856 159.959 25.0381 159.846Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10703_192421",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 64,
    width: 360,
    height: 247
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 64,
    width: 360,
    height: 246.314,
    fill: "#B7588D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10703_192421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.082 79.58V433.62H347.022V79.4043L346.082 79.58Z",
    fill: "#B7588D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.841 101.542V433.619H313.781V100.43C313.5 100.827 313.185 101.199 312.841 101.542Z",
    fill: "#B7588D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.718 165.849V433.619H280.657V163.447C280.246 164.267 279.718 165.029 279.718 165.849Z",
    fill: "#B7588D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.628 218.385V433.62H265.328V222.777L261.628 218.385Z",
    fill: "#B7588D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.357 201.574V433.618H247.297V202.511C247.297 202.511 246.71 201.867 246.357 201.574Z",
    fill: "#B7588D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.116 171.939V433.618H214.056V172.642L213.116 171.939Z",
    fill: "#B7588D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.876 151.383V433.619H180.816V151.851L179.876 151.383Z",
    fill: "#B7588D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.633 138.031V433.621H147.573V138.383L146.633 138.031Z",
    fill: "#B7588D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.393 130.123V433.619H114.332V130.299L113.393 130.123Z",
    fill: "#B7588D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9739 127.43H80.0342V433.62H80.9739V127.605V127.43Z",
    fill: "#B7588D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9082 97.209V433.62H47.8479V97.7946L46.9082 97.209Z",
    fill: "#B7588D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.668 92.6992V433.62H14.6077V92.6406L13.668 92.6992Z",
    fill: "#B7588D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361 226.643H0.277344V228.048H361V226.643Z",
    fill: "#B7588D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361 185.645H272.905L272.376 187.05H361.294L361 185.645Z",
    fill: "#B7588D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.277344 186.757H231.088L229.503 185.352H0.453551L0.277344 186.757Z",
    fill: "#B7588D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361 144.119H288.409C288.409 144.588 287.997 145.056 287.821 145.466H361V144.119Z",
    fill: "#B7588D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.277344 145.466H166.778L163.431 144.119H0.277344V145.466Z",
    fill: "#B7588D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.999 102.832H311.783L310.726 104.238H360.999V102.832Z",
    fill: "#B7588D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.277344 104.238H59.8301L57.7745 102.832H0.277344V104.238Z",
    fill: "#B7588D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361 343.777C349.254 329.487 337.508 311.507 324.587 292.004C306.439 263.151 286.346 235.561 264.447 209.424C287.058 141.486 309.317 79.17 354.775 78.7015H355.303C357.241 78.7015 359.121 78.7015 361.176 78.9943V71.0292C359.297 71.0292 357.418 70.7363 355.303 70.7363H354.657C304.736 71.2634 281.362 133.521 258.281 202.572C235.594 176.723 207.829 155.792 176.704 141.076C148.012 127.87 116.961 120.522 85.3779 119.464C78.419 108.508 68.7512 99.5216 57.3037 93.3676C45.8562 87.2135 33.0138 84.0992 20.0108 84.324C13.3333 84.3326 6.69021 85.279 0.277344 87.1352V95.5689C6.64567 93.3846 13.3351 92.2761 20.0695 92.2891H20.9505C31.5517 92.1207 42.0389 94.4898 51.5323 99.1979C61.0258 103.906 69.2486 110.816 75.5112 119.347C49.8669 119.845 24.4678 124.432 0.277344 132.935V141.486C26.1228 132.036 53.4454 127.237 80.9731 127.312L81.6191 128.367C105.699 169.364 102.292 233.085 73.3969 283.453C64.8715 298.234 54.2711 311.724 41.9173 323.513C29.017 309.073 17.605 293.376 7.85359 276.659C5.15198 272.15 2.68529 267.698 0.277344 263.189V279.588C4.79959 287.201 9.61551 294.757 14.7251 302.019C21.2949 311.316 28.4139 320.214 36.0443 328.667C25.1516 338.149 13.1408 346.272 0.277344 352.855V361.816C15.1203 354.553 28.9423 345.377 41.3887 334.524C71.4587 365.565 104.7 382.725 135.945 382.725H136.826C206.421 382.022 234.436 298.915 261.335 218.033C281.736 242.877 300.585 268.95 317.775 296.104C330.741 316.991 345.124 336.97 360.824 355.901L361 343.777ZM254.404 214.285C228.269 292.941 201.547 374.35 136.943 374.994H136.121C106.756 374.994 75.6874 358.654 47.3792 329.487C60.3022 317.139 71.3962 303.02 80.3271 287.553C109.692 236.072 113.803 171.004 90.3112 127.722C119.083 129.337 147.293 136.33 173.474 148.338C205.025 163.31 233.046 184.766 255.696 211.298C255.05 212.294 254.757 213.289 254.404 214.285Z",
    fill: "#B7588D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361 339.325C347.031 321.731 334.032 303.392 322.061 284.389C303.696 255.153 283.285 227.244 260.982 200.872C284.121 131.177 306.791 66.8698 354.95 66.167H355.538C357.493 66.0414 359.455 66.0414 361.411 66.167V64.2928C359.531 64.2928 357.593 64 355.538 64H354.95C305.91 64.5271 283.064 128.776 259.807 198.705C236.631 171.568 207.972 149.615 175.705 134.281C146.878 121.025 115.643 113.771 83.909 112.962C77.3906 102.186 68.1777 93.2817 57.1724 87.1218C46.167 80.962 33.7463 77.7574 21.1261 77.8219H20.2452C13.5524 77.7987 6.89613 78.8062 0.511698 80.8088V82.7415C6.84429 80.9149 13.4199 80.0656 20.0102 80.2231H20.8912C32.9801 80.1462 44.8882 83.1512 55.4855 88.9527C66.0828 94.7543 75.0177 103.16 81.4423 113.372C53.7898 113.15 26.3144 117.789 0.27677 127.077V129.068C26.6211 119.524 54.472 114.783 82.4995 115.071L84.0852 117.706C108.693 159.523 105.287 224.533 75.863 275.838C66.6729 291.778 55.1081 306.233 41.5643 318.709C27.6569 303.535 15.411 286.925 5.03395 269.161C3.35034 266.272 1.70589 263.402 0.100586 260.552V264.3C5.3276 273.554 11.0245 282.573 17.0737 291.183C24.2438 301.268 32.0926 310.856 40.5659 319.881C28.4624 330.765 14.9518 339.983 0.394234 347.29V349.633C15.331 342.195 29.1657 332.735 41.5056 321.521C71.8693 353.616 105.404 371.303 136.825 370.952C204.6 370.249 232.204 287.142 258.867 206.963L260.101 203.332C282.081 229.214 302.254 256.57 320.476 285.209C332.848 304.926 346.38 323.896 361 342.019V339.325ZM257.281 205.967C230.853 285.677 203.484 368.082 136.943 368.785C105.874 369.136 72.7503 351.566 42.9739 320.056C56.6549 307.477 68.3212 292.88 77.5661 276.775C107.343 224.885 110.749 159.113 85.7884 116.769C85.7884 116.183 85.1424 115.656 84.8487 115.129C115.9 116.103 146.438 123.294 174.648 136.272C207.015 151.732 235.706 173.895 258.809 201.282L257.281 205.967Z",
    fill: "#B7588D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10703_192421",
    x1: 180,
    y1: -213.5,
    x2: 180,
    y2: 242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0CE9E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10703_192421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 246,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBannerBg);
export default __webpack_public_path__ + "static/media/HeaderBannerBg.efc00dda8fd60581173dc469d745098d.svg";
export { ForwardRef as ReactComponent };